<div class="bo-dialog">
<header class="bo-dialog__head">
  <span class="bo-dialog__icon"><i class="bi bi-envelope" aria-hidden="true"></i></span>
  <div class="bo-dialog__heading"><h2 id="text-input-title">{{ modalTitle | translate }}</h2></div>
  <button type="button" class="bo-dialog__close" [attr.aria-label]="'ac_close' | translate"  (click)="activeModal.dismiss()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
</header>

<div class="bo-dialog__body">
  <fieldset class="form-group">
    <label for="text-input" class="form-label">{{ modalDescription }} *</label>
    <input [type]="type" class="form-control" id="text-input" [placeholder]="modalPlaceHolder" [(ngModel)]="inputValue"
      [disabled]="disabled" (blur)="onFieldBlur()" [ngClass]="{
        'is-invalid': type === 'email' && fieldTouched && inputValue && !isValidEmail(),
        'is-valid': type === 'email' && fieldTouched && inputValue && isValidEmail()
      }" />
    <!-- Email validation messages -->
    <div *ngIf="type === 'email' && fieldTouched && inputValue && !isValidEmail()" class="invalid-feedback">
      {{ 'auth_email_invalid' | translate }}
    </div>
  </fieldset>
</div>

<div class="bo-dialog__foot">
  <button type="button" class="bo-dialog__button" (click)="activeModal.dismiss()">
    {{ "ac_cancel" | translate }}
  </button>
  <button type="button" class="bo-dialog__button bo-dialog__button--primary" [disabled]="isSendButtonDisabled()"
    (click)="activeModal.close(inputValue)">
    {{ sendButtonText }}
  </button>
</div>
</div>
